/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
import { PageIcon } from '@/types';
import FabricCanvasExercise, { Props } from '../fabricexercise';
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';

class MarkObject extends FabricCanvasExercise {
  private options: PageIcon[] = []; // Kaynak veriler

  configureCanvas(props: Props) {
    const canvas = this._canvas;
    const sources = [];
    if (props.currentPageItem.sources) {
      this.options = props.currentPageItem.sources;
    }
    let index = 0;
    const backgroundCoordinate = canvas.getBackgroundImageCoordinate();
    for (const option of this.options) {
      const left = option.x + backgroundCoordinate.imgLeft;
      const top = option.y + backgroundCoordinate.imgTop;

      const s = new fabric.Rect({
        width: option.width,
        height: option.height,
        strokeWidth: 1,
        opacity: 1,
        stroke: '#22577a',
        fill: '',
        left,
        top,
        id: `source-${index}`,
        name: `source-${index}`,
        erasable: false,
        selectable: false,
        hasControls: false,
        hasBorders: false,
        pageIcon: true,
      });

      sources.push(s);
      canvas.addObject(s);
    }
    index++;
    let circle = new fabric.Circle();

    // kaynak elemanların sürükleme özelliklerinin ayarlanması
    sources.forEach(function (source) {
      source.on('mousedown:before', (o: any) => {
        canvas.closeDrawingMode();
        circle = new fabric.Circle({
          id: `circle-${source.id}`,
          fill: '',
          left: source.left,
          strokeWidth: 10,
          top: source.top,
          stroke: '#e97f1b',
        });
      });
      source.on('mousedown', function () {
        let isExist = false;
        const objects = canvas.getObjects();
        objects.forEach((o) => {
          if (o.id === `circle-${source.id}`) {
            isExist = true;
          }
        });
        if (!isExist) {
          canvas.addObject(circle);
          fabric.util.animate({
            startValue: 1,
            endValue:
              source.width < source.height
                ? source.width / 2
                : source.height / 2,
            duration: 500,
            easing: fabric.util.ease.easeOutCirc,
            onChange(value: any) {
              circle.set('radius', value);
              canvas.canvasRenderAll();
            },
            onComplete() {},
          });
        } else {
          objects.forEach((o:any) => {
            if (o.id === `circle-${source.id}`) {
              fabric.util.animate({
                startValue: 1,
                endValue: 0,
                duration: 500,
                onChange(value: any) {
                  o.set('opacity', value);
                  canvas.canvasRenderAll();
                },
                onComplete() {
                  canvas.removeObject(o);
                  canvas.canvasRenderAll();
                },
              });
            }
          });
        }

        // Animasyonlu hareket etmek için
        // Animasyon nesnesini oluşturun

        // Animasyonu başlatmak için
      });
      source.on('mouseup', function () {
        canvas.openDrawingMode();
      });
    });
    // this.renderActivityFiles(props, opts);
  }
  onShowPreviousAnswer = async () => {
    console.log('önceki cevap');
  };
  onShowNextAnswer = async () => {
    console.log('sonraki cevap');
  };
  destroy() {
    this.resetOpenedAnswers();
  }
  doMouseDown(o: any) {}

  doMouseMove(o: any) {}

  doMouseUp(o: any) {}
}

export default MarkObject;
